import { getCookie, setCookie } from '../utils/cookies'

const FIRST_TOUCHPOINT = 'GPC'
const FIRST_SEEN_COOKIE_NAME = 'gpc_first_seen'
const REF_COOKIE_NAME = 'gpc_ref'
const REF_GET_PARAM_NAME = 'ref'
const COOKIE_DOMAIN = request?.generalCookieDomain || '.greatpetcare.com'

export default function () {
  // check exists "gpc_first_seen" cookie
  const firstSeenCookie = getCookie(FIRST_SEEN_COOKIE_NAME)

  if (!firstSeenCookie) {
    const userData = getUserData()

    setCookie(
      FIRST_SEEN_COOKIE_NAME,
      JSON.stringify(userData),
      1000 * 60 * 60 * 24 * 365, // 1 year
      COOKIE_DOMAIN
    )
  }

  // update "gpc_ref" cookie if have a "ref" param
  const { search } = window.location
  const params = new URLSearchParams(search)
  const refParam = params.get(REF_GET_PARAM_NAME)

  if (refParam && '' !== refParam) {
    setCookie(
      REF_COOKIE_NAME,
      refParam,
      1000 * 60 * 60 * 24 * 365, // 1 year
      COOKIE_DOMAIN
    )
  }
}

function getUserData() {
  const url = document.location.href
  const date = new Date().toISOString()

  const userData = {
    label: 'FIRST_SEEN',
    origin: FIRST_TOUCHPOINT,
    metadata: {
      url: url,
      touchpoint: FIRST_TOUCHPOINT,
      date: date,
    },
  }

  return userData
}
